<template>
  <ul>
    <li
      v-on:click="reloadData(date, index)"
      v-for="(date, index) in dateslist"
      :key="index"
      v-bind:class="{ active: index == selectedIndex }"
    >
      <a>{{ date.dateno }}</a>
    </li>
  </ul>
</template>

<script>
import moment from "moment-timezone";

export default {
  components: {},
  methods: {
    pollData() {
      this.polling = setInterval(() => {
        this.$emit("reloadProb", {
          date: this.dateslist[this.selectedIndex].date,
          edate: this.dateslist[this.selectedIndex].edate,
          reload: true,
        });
      }, 36000);
    },
    reloadData(date, index) {
      this.selectedIndex = index;
      this.$emit("reloadProb", {
        date: date.date,
        edate: date.edate,
        reload: false,
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  mounted() {
    // Use local machine timezone for all date calculations (matching backend)
    var localNow = moment();
    var _s = this;
    var _ds = [0, 1, 2, 3, 4];

    // Calculate date ranges based on local timezone
    _ds.forEach((ekement) => {
      // Use local timezone for date calculations
      var s = localNow.clone().add(ekement, "days").startOf("day");
      var e = localNow.clone().add(ekement, "days").endOf("day");
      var asa = s;

      // Determine label based on local time
      var localToday = localNow.clone().startOf("day");
      var localTomorrow = localNow.clone().add(1, "days").startOf("day");
      var localYesterday = localNow.clone().add(-1, "days").startOf("day");

      if (s.isAfter(localTomorrow)) {
        asa = s.format("MMM-DD");
      } else if (s.isSame(localTomorrow)) {
        asa = "Tomorrow";
      } else if (s.isSame(localToday)) {
        asa = "Today";
      } else if (s.isSame(localYesterday)) {
        asa = "Yesterday";
      } else {
        asa = s.format("MMM-DD");
      }

      this.dateslist.push({ dateno: asa, date: s, edate: e });
    });

    _s.$emit("reloadProb", {
      date: this.dateslist[0].date,
      edate: this.dateslist[0].edate,
      reload: false,
    });

    this.pollData();
  },

  data() {
    return {
      selectedIndex: 0,
      dateslist: [],
      polling: null,
    };
  },
};
</script>
